import React from 'react';
import { Link } from 'react-router-dom';
import '../assests/css/JoinUs.css';
import Footer from '../Components/Footers/Footer';
import Header from '../Components/Headers/Header';

const JoinUs = () => {
    return (
        <div className='join_us_page'>
            <section className='bg-privacy-policy-top mb-5'>
                <Header />
                <div className='container mb-5 px-5'>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>Join Us</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='join_us_content'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <p class="clr-1c f-25 f-pop-med mt-1 mb-4"> Join our
                                successful and growing team either in the office or on the road</p>
                        </div>
                        <div className='col-lg-6 mt-3'>
                            <input name="fname" type="text" class="form-control p-3 f-14 bg-input-booking f-pop-med" placeholder="First Name" value="" />
                        </div>
                        <div className='col-lg-6 mt-3'>
                            <input name="lname" type="text" class="form-control p-3 f-14 bg-input-booking f-pop-med" placeholder="Last Name" value="" />
                        </div>
                        <div className='col-lg-6 mt-3'>
                            <input name="phone" type="text" class="form-control p-3 f-14 bg-input-booking f-pop-med" placeholder="Phone Number" value="" />
                        </div>
                        <div className='col-lg-6 mt-3'>
                            <input name="email" type="text" class="form-control p-3 f-14 bg-input-booking f-pop-med" placeholder="Email Address" value="" />
                        </div>
                        <div className='col-lg-6 mt-3'>
                            <input name="address" type="text" class="form-control p-3 f-14 bg-input-booking f-pop-med" placeholder="Personal Address" value="" />
                        </div>
                        <div className='col-lg-6 mt-3'>
                            <input name="address" type="text" class="form-control p-3 f-14 bg-input-booking f-pop-med" placeholder="Postal/Zip Code" value="" />
                        </div>
                        <div className='col-lg-6 mt-3'>
                            <input name="address" type="text" class="form-control p-3 f-14 bg-input-booking f-pop-med" placeholder="State Name" value="" />
                        </div>
                        <div className='col-lg-6 mt-3'>
                            <select name="selected_car" class="form-control form-select p-3 f-14 bg-input-booking f-pop-med">
                                <option value="" class="f-pop-med f-14">
                                    Select Working Position
                                </option>
                                <option value="car 1" class="f-pop-med f-14">
                                  On site / In Office
                                </option>
                                <option value="car 2" class="f-pop-med f-14">
                                    Driver / On Road
                                </option>
                            </select>
                        </div>

                        <div class="col-lg-12 mt-3">
                            <textarea name="driver_note" row="5" class="form-control p-3 f-14 bg-input-booking no-resize f-pop-med" placeholder="Comment / Note">
                            </textarea>
                        </div>

                        <div class="col-lg-9  mb-4 mt-5 align-self-center ">
                            <input type="checkbox" class="me-3" />
                            <span class="clr-43">
                                Terms and conditions Easily generate and manage a Terms and Conditions document that is profession
                            </span>
                        </div>

                        <div class="col-lg-3 mb-4 mt-5  text-end">
                            <Link class="link_ourfleet" to="/payment"><button class="btn btn-danger red-clr-btn p-bt-cus f-14 f-pop-med">Proceed</button></Link>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default JoinUs;